document.addEventListener("DOMContentLoaded", function () {
  const articleContent = document.querySelector(".article-template-container");
  if (!articleContent) return;

  let articleCardContent = document.getElementById("article-card_content")?.value || "";

  const shortcodeRegex = /\[product\s+handle="(.*?)"(?:\s+rating="(.*?)")?\]/g;
  const contentHtml = articleContent.innerHTML;

  const loadingHtml = contentHtml.replace(
    shortcodeRegex,
    (match, handle, rating) => {
      return `<div class="product-card-placeholder" 
                   data-product-handle="${handle}" 
                   data-product-rating="${rating || '5'}">loading...</div>`;
    }
  );
  articleContent.innerHTML = loadingHtml;

  const placeholders = articleContent.querySelectorAll(".product-card-placeholder");
  placeholders.forEach((placeholder) => {
    const handle = placeholder.getAttribute("data-product-handle");
    const shortcodeRating = placeholder.getAttribute("data-product-rating");
    fetchProductData(handle, shortcodeRating, placeholder);
  });

  function fetchProductData(handle, shortcodeRating, placeholder) {
    fetch(`/products/${handle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error("The product does not exist.");
        return response.json();
      })
      .then((product) => {
        placeholder.innerHTML = renderProductCard(product, shortcodeRating);
        bindAddToCartEvents(placeholder, product);
      })
      .catch((error) => {
        const errorMsg = `Product loading failed: ${error.message}`;
        placeholder.innerHTML = `<div class="product-card-error">${errorMsg}</div>`;
      });
  }
  
  function renderProductCard(product, shortcodeRating) {
    const variant = product.variants?.[0] || product;
    const imageUrl = product.featured_image || ""; 
    const rating = shortcodeRating ? parseFloat(shortcodeRating) : 5;
    const starObj = { rating: rating }; 
    const starsHtml = generateStarsHtml(starObj.rating);
    const formatMoney = (amount, format) => {
      if (!amount) return "$0.00";
      const price = (amount / 100).toFixed(2); 
      return format ? format.replace("{{amount}}", price) : `$${price}`;
    };

    // 使用兼容写法
    const price = window.theme?.Currency?.formatMoney 
      ? window.theme.Currency.formatMoney(variant.price, window.theme.strings?.moneyFormat || "${{amount}}")
      : formatMoney(variant.price);
    let comparePrice = "";
    if (!!variant.compare_at_price && variant.price < variant.compare_at_price) {
      comparePrice =window.theme?.Currency?.formatMoney 
      ? window.theme.Currency.formatMoney(variant.compare_at_price, window.theme.strings?.moneyFormat || "${{amount}}")
      : formatMoney(variant.compare_at_price);
    }

    return `
      <div class="blog-product-container ${articleContent ? "has_ul" : ""}">
        <div class="blog-product-card">
          <div class="product-info-image">
            <a href="/products/${product.handle}" target="_blank" >
              <img src="${imageUrl}" alt="${product.title}" style="width: 100%; height: auto;" loading="lazy"/>
            </a>
          </div>
          <div class="product-info-content">
            <a href="/products/${product.handle}" target="_blank" class="title-h3">
              <h3>${product.title}</h3>
            </a>
            <p class="product-price">
              <span class="on-sale-price">${price}</span>
              ${comparePrice ? `<span class="compare-at-price">${comparePrice}</span>` : ""}
            </p>
            <div class="product-info-stars">
              ${starsHtml}
            </div>
            <div class="product-info-description">
              ${product.description}
            </div>
            <div class="product-actions">
              <button class="buy-now" data-variant-id="${variant.id}">Buy Now</button>
              <button class="add-to-cart" data-variant-id="${variant.id}">Add To Cart</button>
            </div>
          </div>
        </div>
        <div class="blog-product-promotion-banner">${articleCardContent}</div>
      </div>
    `;
  }

  function generateStarsHtml(rating) {
    const maxStars = 5;
    let starsHtml = "<div class='card-star'>";

    for (let i = 1; i <= maxStars; i++) {
      const isFilled = i <= rating;
      const isHalf = !isFilled && i - 0.5 <= rating;

      starsHtml += `
        <i class="${isFilled ? "fill" : isHalf ? "half" : ""}">
        </i>
      `;
    }
    starsHtml += "</div>";
    return starsHtml;
  }

  function bindAddToCartEvents(card, product) {
    card.querySelector(".add-to-cart").addEventListener("click", function (e) {
      const variantId = this.getAttribute("data-variant-id");
      addToCart(variantId, 1, () => {
        alert("Added To Cart！");
      });
    });

    card.querySelector(".buy-now").addEventListener("click", function (e) {
      const variantId = this.getAttribute("data-variant-id");
      addToCart(variantId, 1, () => {
        window.location.href = "/checkout";
      });
    });
  }

  function addToCart(variantId, quantity, callback) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => {
        if (response.ok) return callback();
        throw new Error("Add purchase failed");
      })
      .catch((error) => {
        alert("error adding to cart");
        console.error(error);
      });
  }
});